const { cleanUpAccents } = require('utilities/stringHelper');

const PROC_INSURANCE_HOME = 'proc-seguros-hogar-solicitud';
const PROC_RELATED_INSURANCE = 'proc-hipotecario-seguros-combinados';

const PRODUCT_NAME_HOME_INSURANCE = {
    BASIC: "Open",
    MEDIUM: "Premium",
    HIGH: "Diamond",
}; 

const EVENTS_INSURANCE_HOME = {
    LANDING_CANCEL_INSURANCE_CLICK: 'LANDING_CANCEL_INSURANCE_CLICK',
    STEP_1_PRECONTRACTUAL_INFO_CLICK: 'STEP_1_PRECONTRACTUAL_INFO_CLICK',
    STEP_2_PROPERTY_CHARACTER_CHANGE: 'STEP_2_PROPERTY_CHARACTER_CHANGE',
    STEP_2_PROPERTY_TYPE_CHANGE: 'STEP_2_PROPERTY_TYPE_CHANGE',
    STEP_2_PROPERTY_USAGE_CHANGE: 'STEP_2_PROPERTY_USAGE_CHANGE',
    STEP_2_OUR_GUIDE_CLICK: 'STEP_2_OUR_GUIDE_CLICK',
    STEP_2_OUR_GUIDE_BUTTON_CLICK: 'STEP_2_OUR_GUIDE_BUTTON_CLICK',
    STEP_3_SELECT_PLAN_CLICK: 'STEP_3_SELECT_PLAN_CLICK',
    STEP_3_LINKS_HOVER: 'STEP_3_LINKS_HOVER',
    STEP_4_GDPR_CLICK: 'STEP_4_GDPR_CLICK'
};

const EVENTS_INSURANCE_HOME_DATA = {
    LANDING_CANCEL_INSURANCE_CLICK: {
        eventName: 'cancelar solicitud'
    },
    STEP_1_PRECONTRACTUAL_INFO_CLICK: {
        eventName: 'ver informacion contractual'
    },
    STEP_2_PROPERTY_CHARACTER_CHANGE: {
        eventName: 'interaccion propiedad',
        eventTag: '%s'
    },
    STEP_2_PROPERTY_TYPE_CHANGE: {
        eventName: 'interaccion tipo propiedad',
        eventTag: '%s'
    },
    STEP_2_PROPERTY_USAGE_CHANGE: {
        eventName: 'interaccion uso vivienda',
        eventTag: '%s'
    },
    STEP_2_OUR_GUIDE_CLICK: {
        eventName: 'ver guia tipos'
    },
    STEP_2_OUR_GUIDE_BUTTON_CLICK: {
        eventName: 'interaccion en guia tipos',
        eventTag: 'asegurar %s'
    },
    STEP_3_SELECT_PLAN_CLICK: {
        eventName: 'interaccion en coberturas',
        eventTag: 'seleccionar %s'
    },
    STEP_3_LINKS_HOVER: {
        eventName: 'ver cobertura',
        eventTag: '%s'
    },
    STEP_4_GDPR_CLICK: {
        eventName: 'ver "texto del enlace"'
    }
};

const getInsuranceTag = (event, extraTag = '') => {
    const data = Object.assign({}, EVENTS_INSURANCE_HOME_DATA[event]);
    if (data.eventTag) {
        const extraTagSanitized = cleanUpAccents(extraTag).replace(/[^\w\s]/gi, '').toLowerCase();
        data.eventTag = data.eventTag.replace(/%s/, extraTagSanitized);
    }
    return data;
};

module.exports = {
    PROC_RELATED_INSURANCE,
    PROC_INSURANCE_HOME,
    EVENTS_INSURANCE_HOME,
    PRODUCT_NAME_HOME_INSURANCE,
    getInsuranceTag,
};